import axios from "axios";
import qs from "qs";
import api_header_config from "@/service/api_header_config";
const api_header = api_header_config.api_header;
const tx_header = api_header_config.tx_header;
import router from '@/router/router';
/**
 * 赋值x-token
 * @param token
 */
let token;
export function setToken(val) {
    token = val;
}

axios.interceptors.response.use(
    (response) => {
        if (response.data.code === 401 || response.data.code === 202) { //无令牌访问
            //清除本地的记录
            window.localStorage.clear();
            window.location.reload()
            sessionStorage.removeItem("competition-management-userInfo");
            router.push('/login')
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export function getExel(url, params) {
    return axios.get(api_header + url, {
        headers: {
            Authorization: 'Bearer '+token,
        },
        params,
        responseType: 'blob'
    }).then((res) => {
        if (!res) return
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf8' })
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);//创建下载的链接
        downloadElement.href = href;
        downloadElement.download = params.ExelName + ".xlsx";//下载后文件名
        // downloadElement.download =decodeURIComponent(
        //     res.headers['content-disposition'].split(";")[1].split("filename=")[1]); // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click();//点击下载
        document.body.removeChild(downloadElement);//下载完成移除元素
        window.URL.revokeObjectURL(href);//释放掉blob对象
    }).catch((e) => {
        console.log(e)
    })
}


//下载zip文件
export function getZip(url, params) {
    return axios.get(api_header + url, {
        params,
        responseType: 'blob',
        headers: {
            Authorization: 'Bearer '+token,
        },
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}


export function get(url, params) {
    return axios.get(api_header + url, {
        params,
        headers: {
            Authorization: 'Bearer '+token,
        },
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}
export function getTx(url, params) {
    return axios.get(tx_header + url, {
        params,
        headers: {
            Authorization: 'Bearer '+token,
        },
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}


export function postLogon(url, params) {
    return axios.post(api_header + url,
        params, {
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}

export function post(url, params) {
    return axios.post(api_header + url,
        params, {
            headers: {
                Authorization: 'Bearer '+token,
            },
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}

export function put(url, params) {
    return axios.put(api_header + url, params,{
        headers: {
            Authorization: 'Bearer '+token,
        },
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}
export function del(url, params) {
    return axios.delete(api_header + url, {
        headers: {
            Authorization: 'Bearer '+token,
        },
        params: params,
        paramsSerializer: (params) => {
            return qs.stringify(params, { indices: false });
            },
    }).then((res) => {
        return res.data;
    }).catch((e) => {
        console.log(e);
    });
}
